import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal } from 'reactstrap';
import { Form } from "formik";
import { injectIntl } from 'react-intl';
import { CouponInfo } from "../CouponInfo";

function AddCouponInCampaignModalComponent(props) {
  const {
    campaign,
    initialValues,
    setInitialValues,
    formikProps,
    toggleModal,
    setToggleModal,
    updateFormikProps,
  } = props;

  return (
    <Modal
      className="modal-dialog-centered campaign-coupon-modal"
      isOpen={ toggleModal }
      size="xl"
      toggle={
        () => setToggleModal(false)
      }
    >
      <Form>
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            <FormattedMessage id="components.pages.campaignManagement.createCampaignForm.coupon_details"/>
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={
              () => setToggleModal(false)
            }
          >
            <span aria-hidden={true}>&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <CouponInfo
            campaign={ campaign }
            formikProps={ formikProps }
            initialValues={ initialValues }
            setInitialValues={ setInitialValues }
            updateFormikProps={ updateFormikProps }
          />
        </div>
        <div className="modal-footer">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={
              () => setToggleModal(false)
            }
          >
            <FormattedMessage id="button.cancel"/>
          </Button>
          <Button color="primary" type="submit" name="save">
            <FormattedMessage id="button.add_coupon" />
          </Button>
        </div>
      </Form>
    </Modal>
  )
}


const AddCouponInCampaignModal = injectIntl(AddCouponInCampaignModalComponent);
export { AddCouponInCampaignModal, AddCouponInCampaignModalComponent };
